import { Controller } from "stimulus";
let debounce = require('lodash/debounce');

export default class extends Controller {
  static targets = ['startAtDatePicker', 'endAtDatePicker'];

  static values = {
    defaultAccessPeriod: Number
  }

  connect() {
    this.startAtDatePickerTarget.addEventListener('change', this.setEndDate.bind(this));
  }

  setEndDate(event) {
    if (this.endAtDatePickerTarget.value !== '') {
      return false;
    }

    const startDate = new Date(event.target.value);
    const utcStartDate = new Date(startDate.getTime() + startDate.getTimezoneOffset());
    const utcEndDate = new Date(Date.UTC(utcStartDate.getFullYear(), utcStartDate.getMonth() + this.defaultAccessPeriodValue, utcStartDate.getDate()));

    this.endAtDatePickerTarget.dispatchEvent(new CustomEvent('promote:datepicker-change', {
      detail: { value: utcEndDate.toISOString().slice(0, 10) }
    }));
  }
}
